module.exports = __webpack_public_path__ + "static/media/Dong Yang.87bf232e.png";